import * as React from "react";

import { Grid, Typography } from "@mui/material";

import Select from "./Select";

import { ReactComponent as ModelSelectionIcon } from "../../assets/model_selection.svg";
import { ReactComponent as ImageSvg } from "../../assets/image.svg";
import { COLLECTION } from "../../data/constants";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxhook";
import { getType } from "../../redux/slices/typeSlice";
import { useTheme } from "@mui/material";
import { brandingSettings } from "../../branding";
export default function SelectModal() {
  const chatType = useAppSelector(getType);
  const theme = useTheme();
  return (
    <Grid id="selectmodel"
      container
      sx={{
        width: "350px",
        position: "relative",
      }}
      direction="row"
      alignItems="center"
      item
    >
      <Grid container alignItems="center">
        <Grid item display="flex" flexDirection="row">
          <ModelSelectionIcon
            width="22px"
            style={{
              marginTop: "-2px",
            }}
          />
          <Typography sx={{
            color: theme.palette.mode === 'dark' ? brandingSettings.textcolorPrimaryDark : brandingSettings.textcolorPrimary,
          }}>&nbsp;Model&nbsp;&nbsp;: &nbsp;&nbsp;</Typography>
        </Grid>
        <Grid item width="65%">
          <Select />
        </Grid>
      </Grid>
      {chatType.type === "Collections" && (
        <>
          <Grid container alignItems="center" mt="2%">
            <Grid item display="flex" flexDirection="row">
              <ImageSvg style={{
                  marginTop: "-2px",width:"22px"
                }}/>
              <Typography sx={{
            color: theme.palette.mode === 'dark' ? brandingSettings.textcolorPrimaryDark : brandingSettings.textcolorPrimary,
          }}>&nbsp;Image&nbsp;: &nbsp;&nbsp;</Typography>
            </Grid>
            <Grid item width="65%">
              <Select type={COLLECTION} />
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
}
